import gql from 'graphql-tag';
import { DEAL_BUILDER_ENTITY_FRAGMENT } from './fragments/dealBuilderEntity.fragment';

export const GET_DEAL_BUILDERS = gql`
  query GetDealBuilders($vendorOpportunityId: ID!) {
    dealBuilder {
      getDealBuilders(vendorOpportunityId: $vendorOpportunityId) {
        success
        error
        entity {
          ...DealBuilderEntityFields
        }
      }
    }
  }
  ${DEAL_BUILDER_ENTITY_FRAGMENT}
`;
